import { useEffect } from "react";
import { EMessageTypes, EDepositStatus } from "src/types";
import { isNestedIframe } from "src/utils";

export const useSendDepositStatusRedirect = (status: EDepositStatus | undefined) => {
  useEffect(() => {
    if (!status) return;

    // Check if we're inside a nested iframe
    if (isNestedIframe()) {
      // We're in a nested iframe, send message to parent to navigate
      window.parent.postMessage(
        {
          type: EMessageTypes.DepositStatusRedirect,
          status: status,
        },
        "*"
      );
    }
  }, [status]);
};
